<template>
  <b-modal
    id="foreign-under-18-modal"
    v-model="isVisible"
    centered
    hide-header
    hide-header-close
    hide-footer
    :no-close-on-backdrop="false"
    :no-close-on-esc="true"
    content-class="gnv-flow-modal-content"
    body-class="gnv-flow-modal-body p-0"
  >
    <div class="gnv-flow-modal gnv-flow-modal--dark-theme">
      <div class="gnv-flow-modal__top-bar" />

      <div class="gnv-flow-modal__inner">
        <h4 class="gnv-flow-modal__title">
          {{ $t('foreignUnder18.title') }}
        </h4>

        <p class="gnv-flow-modal__message">
          {{ $t('foreignUnder18.message') }}
        </p>

        <div class="gnv-flow-modal__actions gnv-flow-modal__actions--single gnv-flow-modal__actions--stacked">
          <button
            type="button"
            class="gnv-flow-modal__btn gnv-flow-modal__btn--primary"
            @click="confirm"
          >
            {{ $t('common.understood') }}
          </button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ForeignUnder18Modal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      },
    },
  },
  methods: {
    confirm() {
      this.isVisible = false
    },
  },
}
</script>
